'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MastercardIcon = function MastercardIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Mastercard' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("polygon", {
      fill: "#FF5F00",
      points: "9.471 11.133 14.532 11.133 14.532 2.867 9.471 2.867"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M9.9917,7.0004 C9.9907,5.3884 10.7307,3.8634 11.9997,2.8684 C9.7177,1.0744 6.4127,1.4714 4.6187,3.7534 C2.8257,6.0354 3.2207,9.3404 5.5037,11.1344 C7.4097,12.6324 10.0937,12.6324 11.9997,11.1344 C10.7307,10.1384 9.9907,8.6134 9.9917,7.0004",
      fill: "#EB001B"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M20.5044,7.0004 C20.5044,9.9034 18.1504,12.2564 15.2484,12.2564 C14.0694,12.2564 12.9264,11.8604 11.9994,11.1324 C14.2814,9.3384 14.6784,6.0344 12.8844,3.7514 C12.6254,3.4224 12.3284,3.1254 11.9994,2.8664 C14.2814,1.0724 17.5864,1.4684 19.3804,3.7504 C20.1084,4.6764 20.5044,5.8204 20.5044,6.9984 L20.5044,7.0004 Z",
      fill: "#F79E1B"
    })]
  }));
};
MastercardIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MastercardIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Mastercard'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var MastercardIcon$1 = MastercardIcon;
MastercardIcon.propTypes = {
  title: PropTypes__default.default.string
};

exports.default = MastercardIcon$1;
//# sourceMappingURL=MastercardIcon.js.map
